import { createSelector } from '@ngrx/store';

import { betslipSelector } from '../../base/store/selectors';

export const trackingSelector = createSelector(betslipSelector, (s) => s.tracking);
export const trackingLdActiveExperimentsSelector = createSelector(trackingSelector, (s) => s.ldActiveExperiments);
